// extracted by mini-css-extract-plugin
export default {"container":"erGr00EY20NQraM6dBHY9A==","icon":"PZTCH3qeRiMJnaKINE52cw==","close":"_4xIppc28egDbnbthCvvmBg==","message":"WWe5sOs6sUT5Uo+E0r6PqQ=="};